import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import TestosteroneReplacementTherapyTrt from "./sections/TestosteroneReplacementTherapyTrt";
import LongevitySolutions from "./sections/LongevitySolutions";
import CoreServices from "./sections/CoreServices";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <div className="w-full overflow-hidden">
        <img src="https://ironpeakmenshealth.com/wp-content/uploads/2026/03/Mens-Health-Services.png" alt="IronPeak Men's Health Services" className="w-full object-cover" style={{
        maxHeight: "480px",
        objectPosition: "top center"
      }} />
      </div>
      <TestosteroneReplacementTherapyTrt />
      <CoreServices />
      
      <Footer />
    </div>;
}